import type { LucideIcon } from "lucide-react";

export function Btn({
  icon: Icon,
  children,
  onClick,
  iconClass = "",
  variant = "secondary",
  size = "md",
  disabled = false,
  type = "button",
}: {
  icon?: LucideIcon;
  children: React.ReactNode;
  onClick?: () => void;
  iconClass?: string;
  variant?: "secondary" | "primary" | "danger" | "ghost";
  size?: "sm" | "md";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}) {
  const sz =
    size === "sm" ? "px-2.5 py-1.5 text-[12px]" : "px-3.5 py-2 text-[13px]";
  const variants = {
    secondary:
      "border border-[var(--color-border-strong)] bg-[var(--color-surface)] text-[var(--color-fg)] hover:-translate-y-px hover:border-[var(--color-fg-muted)] hover:shadow-[0_4px_12px_-4px_rgba(15,23,42,0.12)] active:translate-y-0",
    primary:
      "bg-[var(--color-brand)] text-white hover:bg-[var(--color-navy-700)]",
    danger:
      "border border-[var(--color-danger)] bg-[var(--color-surface)] text-[var(--color-danger)] hover:bg-[var(--color-danger-bg)]",
    ghost:
      "border border-transparent text-[var(--color-fg-muted)] hover:bg-[var(--color-surface-2)] hover:text-[var(--color-fg)]",
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center gap-2 rounded-lg font-medium transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-50 ${sz} ${variants[variant]}`}
    >
      {Icon && <Icon size={14} className={"opacity-70 " + iconClass} />}
      {children}
    </button>
  );
}
